(() => {
  function install(root=document) {
    root.querySelectorAll('[data-fl4-gallery]').forEach(gallery => {
      if (gallery.dataset.fl4Bound) return;
      gallery.dataset.fl4Bound='true';
      const frames=Array.from(gallery.querySelectorAll('[data-fl4-frame]'));
      const thumbs=Array.from(gallery.querySelectorAll('[data-fl4-select]'));
      const ready=new WeakMap();
      let request=0;
      const decode=frame => {
        if (ready.has(frame)) return ready.get(frame);
        const img=frame.querySelector('img');
        const promise=(img.decode ? img.decode() : new Promise((resolve,reject) => {
          if(img.complete) { img.naturalWidth ? resolve() : reject(); return; }
          img.addEventListener('load',resolve,{once:true}); img.addEventListener('error',reject,{once:true});
        })).then(()=>true).catch(()=>false);
        ready.set(frame,promise);return promise;
      };
      async function select(id) {
        const frame=frames.find(f=>f.dataset.fl4Frame===String(id));
        if(!frame) return;
        const ticket=++request;
        gallery.dataset.fl4Requested=String(id);
        if(frame.classList.contains('is-active')) return;
        const loaded=await decode(frame);
        if(ticket!==request || !loaded) return;
        frames.forEach(f=>{const active=f===frame;f.classList.toggle('is-active',active);f.setAttribute('aria-hidden',String(!active));});
        thumbs.forEach(b=>{const active=b.dataset.fl4Select===String(id);b.classList.toggle('is-active',active);b.setAttribute('aria-current',String(active));});
        gallery.dataset.fl4Displayed=String(id);
      }

      // The files have different amounts of white canvas. Measure the visible shoe,
      // not the image element, and only adjust tall, substantial three-quarter/top views.
      // The lead image and Balenciaga gallery remain exactly as they are.
      if (gallery.dataset.fl4Brand.toLowerCase() !== 'balenciaga') {
        frames.slice(1).forEach(frame => {
          const img = frame.querySelector('img');
          decode(frame).then(loaded => {
            if (!loaded || !img.naturalWidth || !img.naturalHeight) return;
            try {
              const sample = document.createElement('canvas');
              sample.width = 96;
              sample.height = 96;
              const context = sample.getContext('2d', {willReadFrequently:true});
              if (!context) return;
              context.drawImage(img, 0, 0, 96, 96);
              const pixels = context.getImageData(0, 0, 96, 96).data;
              let left=96, top=96, right=-1, bottom=-1;
              for (let y=0; y<96; y++) for (let x=0; x<96; x++) {
                const k=(y*96+x)*4;
                if (pixels[k+3]<40 || (pixels[k]>242 && pixels[k+1]>242 && pixels[k+2]>242)) continue;
                left=Math.min(left,x); right=Math.max(right,x);
                top=Math.min(top,y); bottom=Math.max(bottom,y);
              }
              if (right<left || bottom<top) return;
              const canvasWidth=gallery.querySelector('.fl4-gallery-canvas').getBoundingClientRect().width;
              const imageWidth=img.getBoundingClientRect().width;
              if (!canvasWidth || !imageWidth) return;
              const visibleWidth=imageWidth*(right-left+1)/96;
              const visibleHeight=imageWidth*(img.naturalHeight/img.naturalWidth)*(bottom-top+1)/96;
              // Side profiles are wide and shallow; front/rear views are narrow.
              if (visibleHeight/canvasWidth < .56 || visibleWidth/canvasWidth < .38 ||
                  visibleWidth/visibleHeight > 1.65) return;
              const scale=Math.max(.66, Math.min(1, canvasWidth*.52/visibleHeight));
              if (scale < .98) {
                frame.style.setProperty('--fl4-perspective-scale', scale.toFixed(3));
                frame.classList.add('is-fl4-perspective');
              }
            } catch (_) {
              // If pixels cannot be read (for example a CDN CORS restriction),
              // keep the original photograph unchanged.
            }
          });
        });
      }
      thumbs.forEach(b=>b.addEventListener('click',()=>select(b.dataset.fl4Select)));
      frames.forEach(decode);
      document.addEventListener('fl4:select-media',event=>select(event.detail));
      let touch=null;
      const stage=gallery.querySelector('[data-fl4-stage]');
      stage.addEventListener('touchstart',e=>{touch=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
      stage.addEventListener('touchend',e=>{if(!touch)return;const t=e.changedTouches[0],dx=t.clientX-touch.x,dy=t.clientY-touch.y;touch=null;if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.4)return;const current=frames.findIndex(f=>f.classList.contains('is-active'));const next=(current+(dx<0?1:-1)+frames.length)%frames.length;select(frames[next].dataset.fl4Frame);},{passive:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>install(),{once:true});else install();
  document.addEventListener('shopify:section:load',e=>install(e.target));
})();
